// extracted by mini-css-extract-plugin
module.exports = {"jinaLogo":"website_jinaLogo____1Po","watercrawlLogo":"website_watercrawlLogo__zIgIi"};